import * as React from "react";

function SvgSpacerIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.6.8c0-.5.3-.8.7-.8h16c.4 0 .8.3.8.8s-.3.8-.8.8h-16c-.4-.1-.7-.4-.7-.8zm16.7 17.7h-16c-.4 0-.8.3-.8.8 0 .4.3.8.8.8h16c.4 0 .8-.3.8-.8s-.4-.8-.8-.8zM13.2 6.7c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1l-3.4-3.4c-.3-.3-.8-.3-1.1 0L6.4 5.6c-.3.3-.3.8 0 1.1.1.1.3.2.5.2s.4-.1.5-.2l2.1-2.1v11l-2.1-2.1c-.3-.3-.8-.3-1.1 0-.3.3-.3.8 0 1.1L9.7 18c.1.1.3.2.5.2s.4-.1.5-.2l3.4-3.4c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-2.1 2.1v-11l2.3 2.1z" /></svg>;
}

export default SvgSpacerIcon;